import React from "react";
import { HiBolt } from "react-icons/hi2";
import { MdOutlineDesignServices } from "react-icons/md";
import { FaRocket } from "react-icons/fa";
import "./AndroidIntroSection.css";

const AndroidIntroSection = () => {

    return (
        <>
            <section className="android-intro-section">

                {/* Background Effects */}
                <div className="android-blur blur-one"></div>
                <div className="android-blur blur-two"></div>

                <div className="android-intro-container">

                    {/* LEFT CONTENT */}
                    <div className="intro-left">

                        <span className="intro-badge">
                            ANDROID APP DEVELOPMENT
                        </span>

                        <h2>
                            Android Apps That
                            <span> Users Love.</span>
                        </h2>

                        <p>
                            At AppVerseLabs, we build premium Android applications
                            with stunning UI, ultra-smooth performance and scalable
                            architecture designed for startups & enterprises.
                        </p>

                        <div className="intro-points">

                            <div className="point-card">
                                <div className="point-icon">
                                    <HiBolt />
                                </div>

                                <div>
                                    <h4>Blazing Fast Performance</h4>

                                    <p>
                                        Optimized Android apps with smooth
                                        interactions & lightning-fast loading.
                                    </p>
                                </div>
                            </div>

                            <div className="point-card">
                                <div className="point-icon">
                                    <MdOutlineDesignServices />
                                </div>

                                <div>
                                    <h4>Premium UI/UX</h4>

                                    <p>
                                        Modern Android interfaces crafted for
                                        engagement & seamless user experience.
                                    </p>
                                </div>
                            </div>

                            <div className="point-card">
                                <div className="point-icon">
                                    <FaRocket />
                                </div>

                                <div>
                                    <h4>Launch & Scale</h4>

                                    <p>
                                        From Play Store launch to scaling millions
                                        of users — we handle everything.
                                    </p>
                                </div>
                            </div>

                        </div>

                    </div>

                    {/* RIGHT PHONE UI */}
                    <div className="intro-right">

                        <div className="android-phone">

                            <div className="phone-frame">

                                <div className="phone-notch"></div>

                                <div className="phone-screen">

                                    <div className="screen-glow"></div>

                                    <div className="screen-content">

                                        <h3>Android Apps</h3>

                                        <p>
                                            Build powerful mobile experiences
                                        </p>

                                        <div className="screen-stats">

                                            <div className="stat-card">
                                                <span>Performance</span>
                                                <strong>98%</strong>
                                            </div>

                                            <div className="stat-card">
                                                <span>Users</span>
                                                <strong>1M+</strong>
                                            </div>

                                        </div>

                                    </div>

                                </div>

                            </div>

                        </div>
                    </div>

                </div>
                <style>
                    {`.android-phone{
    width:320px;
    height:650px;
    position:relative;
}

.phone-frame{
    width:100%;
    height:100%;
    background:linear-gradient(
        145deg,
        #1f1f1f,
        #090909
    );
    border-radius:48px;
    padding:10px;
    position:relative;

    box-shadow:
    0 40px 80px rgba(0,0,0,.5),
    inset 0 1px 0 rgba(255,255,255,.08);
}

.phone-screen{
    width:100%;
    height:100%;
    border-radius:40px;
    overflow:hidden;
    position:relative;

    background:
    radial-gradient(
        circle at top right,
        rgba(0,229,255,.18),
        transparent 30%
    ),
    radial-gradient(
        circle at bottom left,
        rgba(37,99,235,.18),
        transparent 40%
    ),
    #050505;
}

.phone-notch{
    position:absolute;
    top:18px;
    left:50%;
    transform:translateX(-50%);
    width:120px;
    height:28px;
    background:#000;
    border-radius:30px;
    z-index:10;
}

.screen-glow{
    position:absolute;
    inset:0;

    background:
    radial-gradient(
        circle at 50% 20%,
        rgba(0,229,255,.15),
        transparent 35%
    );
}

.screen-content{
        padding: 90px 0px 25px;
    position:relative;
    z-index:2;
}

.screen-content h3{
    color:#fff;
    font-size:34px;
    line-height:1.1;
    margin-bottom:10px;
}

.screen-content p{
    color:#8b949e;
    margin-bottom:35px;
}

.screen-stats{
    display:flex;
    flex-direction:column;
    gap:15px;
}

.stat-card{
    background:rgba(255,255,255,.03);
    border:1px solid rgba(255,255,255,.06);
    backdrop-filter:blur(20px);
    border-radius:20px;
    padding:18px;
}

.stat-card span{
    display:block;
    color:#7d8790;
    margin-bottom:8px;
}

.stat-card strong{
    color:#00e5ff;
    font-size:28px;
}`}
                </style>
            </section>
        </>
    );
};

export default AndroidIntroSection;